
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alternative-products",
      function () {
        return require("private-next-pages/alternative-products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alternative-products"])
      });
    }
  